/**
 * Exhaustiveness tripwire for a discriminated branch.
 *
 * @remarks Replaces a trailing `return <default>` at the end of an if-chain over a union. Those
 * defaults are dead code for every DECLARED input — and that is the problem, not the benefit: they
 * are what lets a NEW union member compile and silently resolve to whatever the default happens to
 * be. In `consult-tabs.ts` and `consult-content-shell.tsx` the defaults were `['group', '1:1']` and
 * `'dual'`, so adding a fifth `ConsultType` would have quietly offered the member both scheduling
 * modes and dual hero copy, with neither a compile-time nor a runtime signal.
 *
 * With this, the same omission is a TYPE ERROR at build time — the argument stops being assignable
 * to `never` — which is the point. The runtime throw is the secondary half, for a value that got
 * past the type system anyway; `useConsultExchange` validates `consultType` at the JSON boundary
 * precisely so that cannot happen, and `ConsultErrorBoundary` contains it if it somehow does.
 */
export function assertNever(value: never): never {
  throw new Error(`Unhandled union member: ${JSON.stringify(value)}`);
}
